<div class="spinner-container {{ position }} {{ textAlign }} " [ngClass]="{ 'has-overlay': overlay, 'd-inline': inline }">
    <div id="spinner-mode" class="spinner loading">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
    <div class="text-center">{{ text }}</div>
</div>
<div class="overlay" *ngIf="overlay"></div>
